import { connect } from 'react-redux';
import cookiesFactory from '../../../../../base/cookies-factory';
import SavedToMyAccountMessage from './SavedToMyAccountMessage';

const mapStateToProps = ({ estimateBuilder }) => ({
  estimateName:
    estimateBuilder.entities.estimates.byId[estimateBuilder.uiState.selectedEstimate].name,
  isLinked:
   estimateBuilder.entities.estimates.byId[estimateBuilder.uiState.selectedEstimate].isLinked,
  isInternalUser:
    cookiesFactory.isInternalUser(),
  customerEmail:
    estimateBuilder.entities.estimates.byId[estimateBuilder.uiState.selectedEstimate].sharedEmail,
});

export default connect(mapStateToProps)(SavedToMyAccountMessage);
